/*
 * 戒导航 · 戒打卡模块（jiedh/checkin）—— 前端「打卡记录」模型
 *
 * 设计依据：doc/戒打卡功能设计方案.md §18.3 ①、§18.5。
 *
 * ★ 必须在前台 extend.ts 注册（type 与后端完全一致）：
 *   new Extend.Store().add('jiedh-checkin-records', CheckinRecord)
 *   后端 JieDH\Checkin\Api\Resource\CheckinRecordResource::type() 返回 'jiedh-checkin-records'。
 *
 * 属性/关系名与后端 CheckinRecordResource::fields() 一一对应。
 * 状态常量与后端 CheckinRecord::STATUS_SUCCESS / STATUS_RELAPSE 保持一致。
 */
import Model from 'flarum/common/Model';
/** 成功打卡（与后端 CheckinRecord::STATUS_SUCCESS 一致）。 */
export const STATUS_SUCCESS = 1;
/** 破戒（与后端 CheckinRecord::STATUS_RELAPSE 一致）。 */
export const STATUS_RELAPSE = 0;
export default class CheckinRecord extends Model {
  /**
   * 打卡日期（YYYY-MM-DD，后端按站点时区计算，**完全只读**）。
   *
   * 后端用 Schema\Date 输出，序列化后是 'YYYY-MM-DD' 字符串；
   * 这里保持字符串原样（不当 Date 解析，避免时区偏移把日期回退一天）。
   * 前端只做展示与分组，绝不可写回。
   */
  checkinDate() {
    return Model.attribute('checkinDate').call(this);
  }

  /** 状态：STATUS_SUCCESS(1) / STATUS_RELAPSE(0)。仅新建时可写。 */
  status() {
    return Model.attribute('status').call(this);
  }

  /** 心情 1–5，可空。 */
  mood() {
    return Model.attribute('mood').call(this);
  }

  /** 备注，可空。 */
  note() {
    return Model.attribute('note').call(this);
  }

  /** 是否补签（P2）。 */
  isMakeup() {
    return Model.attribute('isMakeup').call(this);
  }

  /** 创建时间（只读）。 */
  createdAt() {
    return Model.attribute('createdAt', v => v ? new Date(v) : null).call(this);
  }

  /** 归属目标关系（includable）。 */
  habit() {
    return Model.hasOne('habit').call(this);
  }
}
flarum.reg.add('jiedh-checkin', 'common/models/CheckinRecord', CheckinRecord);